module.exports = __webpack_public_path__ + "img/video-player/yay@3x-61e5ce8364a09c36e7a38c93cd9da442.png";